module.exports = __webpack_public_path__ + "img/Vaske-og-Rengøringsmidler.4e665770.jpg";